import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyWivPromotionIcon = lazy(() => import('./svg-components/wiv-promotion-icon'));

const WivPromotionIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyWivPromotionIcon {...rest} />
  </Suspense>
);

export default WivPromotionIcon;
